import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

export interface InvestorOverviewSummaryResponse {
  cashBalance: number;
  activeNoteCount: number;
  closedNoteCount: number;
  totalInvestedPrincipal: number;
  totalRepaidPrincipal: number;
  outstandingPrincipal: number;
  totalExpectedInterest: number;
  totalRepaidInterest: number;
  outstandingInterest: number;
}

interface InvestorOverviewSummaryRequest {
  token: string;
  orgRoleId: number;
}

const getInvestorOverviewSummary = async ({
  token,
  orgRoleId,
}: InvestorOverviewSummaryRequest): Promise<InvestorOverviewSummaryResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/dashboard/investor-overview-summary/${orgRoleId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getInvestorOverviewSummary;
